import { render } from "./vueBridge.vue?vue&type=template&id=15b0a925&scoped=true"
import script from "./vueBridge.vue?vue&type=script&lang=js"
export * from "./vueBridge.vue?vue&type=script&lang=js"

import "./vueBridge.vue?vue&type=style&index=0&id=15b0a925&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b0a925"]])

export default __exports__